module.exports = __webpack_public_path__ + "static/media/YourEmpty.270a6f19.svg";